<div class="row">
  <div class="col-md-12">
    <dg-emp-search-dialog
      class="addRemoveUserEmpSearchDialog"
      #addRemoveUserEmpSearch
      *ngIf="showEmpSearch"
      [multiSelectTemplate]="multiSelectTemplate"
      [selectedEmployeeList]="selectedEmployeesUnitId"
      [inputData]="configData"
      [enableRole]="enableRole"
      [showFilter]="false"
      [orgId]="''"
      [showAllEmps]="true"
      [isDisplayLoginEmp]="false"
      [defaultUserImgPath]="'./assets/images/home-emp-logo.png'"
      (changeData)="getEmpData($event)"
    >
    </dg-emp-search-dialog>
  </div>
</div>
<ng-template #multiSelectTemplate let-employee>
  <div class="row mx-0 py-2 w-100 align-items-center">
    <div class="col-2 p-0">
      <img
        class="employee-image"
        [src]="
          employee?.IMG_FILE_BYTES
            ? 'data:image/' +
              employee?.DOC_FILE_TYPE +
              ';base64,' +
              employee?.IMG_FILE_BYTES
            : '/assets/images/user-profile.PNG'
        "
        alt="Employee"
      />
    </div>
    <div class="col-7 pe-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="employee-name dg-fs-16">
            {{ employee?.FULL_NAME }}
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="employee-org dg-fs-14">
            {{
              employee?.UNIT_NAME
                ? employee?.UNIT_NAME + ", " + employee?.ORG_NAME
                : employee?.USER_NAME
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-3 p-0">
      <div class="row text-end m-0">
        <div
          class="col-12 p-0"
          *ngIf="
            getIsGrpAdminVal(employee) != 1 && getIsGrpAdminVal(employee) != 2
          "
        >
          <button
            mat-icon-button
            class="dg-txt-primary icon"
            (click)="removeEmp(employee)"
          >
            <mat-icon class="">delete_outline</mat-icon>
          </button>
        </div>
        <div class="col-12 p-0" *ngIf="getIsGrpAdminVal(employee) === 1">
          <button mat-icon-button class="dg-txt-primary icon ms-2">
            <mat-icon class="material-icons-outlined"
              >admin_panel_settings</mat-icon
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<mat-dialog-actions align="end">
  <button mat-button mat-raised-button mat-dialog-close>Cancel</button>
  <button
    mat-button
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="isSubmitDisable()"
  >
    Submit
  </button>
</mat-dialog-actions>
